import React, { KeyboardEvent } from 'react';
import { styles } from './HeaderMenuButton.css';
import { CloseIcon } from '@jbhi-fi/lanyard-ui/components/Icons/Close';
import { HamburgerIcon } from '@jbhi-fi/lanyard-ui/components/Icons/Hamburger';

export type HeaderMenuButtonProps = {
  onClick: React.MouseEventHandler<HTMLDivElement>;
  isOpen: boolean;
};

export const HeaderMenuButton = ({ onClick, isOpen }: HeaderMenuButtonProps) => {
  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if ([' ', 'Enter'].includes(e.key)) onClick(e as unknown as React.MouseEvent<HTMLDivElement>);
  };

  return (
    <div className={styles.container} onClick={onClick} onKeyDown={handleKeyDown} role={'button'} tabIndex={0}>
      <div className="mobile-menu">
        <div className={styles.iconContainer}>{isOpen ? <CloseIcon /> : <HamburgerIcon />}</div>
        <div>Menu</div>
      </div>
    </div>
  );
};
